// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1029) return "static/chunks/1029-e7f10aba161ac005.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2084":"9b0008ae","3309":"685f7497"}[chunkId] || chunkId) + "." + {"1713":"719998e22bba409d","2084":"420b0a2a2c736bab","3309":"aa093705bed73d69","3883":"ee6bfa821c8e2963","6676":"bf58bd9f6f8a7754","9955":"0a1a989e7e20e21a"}[chunkId] + ".js";
};